import { calculateTotalAllBrands, TCalculateTotalAllBrandsParams } from './calculateTotalAllBrands'
import { calculateTotalHP, TCalculateTotalHPParams } from './calculateTotalHP'

export interface ICalculateTotalPercentageParams
  extends TCalculateTotalAllBrandsParams,
    TCalculateTotalHPParams {}

export const calculateTotalPercentage = (data: ICalculateTotalPercentageParams) => {
  const totalHP = calculateTotalHP({
    a3HP: data.a3HP,
    a4HP: data.a4HP,
  })

  const totalAllBrands = calculateTotalAllBrands({
    a3AllBrands: data.a3AllBrands,
    a4AllBrands: data.a4AllBrands,
  })

  const percentage = (totalHP / Math.max(totalAllBrands, 1)) * 100

  return Math.round(percentage)
}
